// extracted by mini-css-extract-plugin
export default {"loading":"ParentWeek_loading__WXDTu","badges":"ParentWeek_badges__QZW7j"};